












































import Vue from "vue";
import moment from "moment";
import { mapGetters, mapState } from "vuex";
import { RootState } from "@/store";

//Components
import InstallationTreePathWithResumeDialog from "@/components/InstallationTreePathWithResumeDialog.vue";
import { InstallationWebSocketMetric } from "@/model/data/networkMetrics/InstallationWebSocketMetric";
import { formatBytes } from "@/utility/Formatter";

export default Vue.extend({
    components: {
        InstallationTreePathWithResumeDialog,
    },
    computed: {
        ...mapGetters(["userDateFormat"]),
        ...mapState({
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
        }),
        networkInSeries() {
            if (this.installation.metrics && this.installation.metrics.length > 0)
                return [{ name: this.$t("network_metrics.networkInTrend__title"), data: this.installation.metrics.map((m) => m.byteReceived) }];
            return [];
        },
        networkOutSeries() {
            if (this.installation.metrics && this.installation.metrics.length > 0)
                return [{ name: this.$t("network_metrics.networkOutTrend__title"), data: this.installation.metrics.map((m) => m.byteSent) }];
            return [];
        },
        dateList() {
            let dateListString = [];
            if (this.installation.metrics && this.installation.metrics.length > 0)
                this.installation.metrics.forEach((m) => {
                    dateListString.push(moment(m.dateTime).format(this.userDateFormat));
                });
            return dateListString;
        },
        chartNetworkInTrend() {
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "line",
                        zoom: {
                            enabled: false,
                        },
                        animations: {
                            enabled: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: "straight",
                    },
                    title: {
                        text: this.$t("network_metrics.networkInTrend__title"),
                        align: "left",
                    },
                    grid: {
                        row: {
                            colors: ["#f3f3f3", "transparent"],
                            opacity: 0.5,
                        },
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    xaxis: {
                        type: "category",
                        categories: this.dateList,
                        tickAmount: 4,
                    },
                    yaxis: {
                        labels: {
                            formatter: (value) => (value != null ? formatBytes(value, true, 2) : null),
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => (value != null ? formatBytes(value, true, 2) : null),
                        },
                    },
                },
                series: this.networkInSeries,
            };
        },
        chartNetworkOutTrend() {
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "line",
                        zoom: {
                            enabled: false,
                        },
                        animations: {
                            enabled: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: "straight",
                    },
                    title: {
                        text: this.$t("network_metrics.networkOutTrend__title"),
                        align: "left",
                    },
                    grid: {
                        row: {
                            colors: ["#f3f3f3", "transparent"],
                            opacity: 0.5,
                        },
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    xaxis: {
                        type: "category",
                        categories: this.dateList,
                        tickAmount: 4,
                    },
                    yaxis: {
                        labels: {
                            formatter: (value) => (value != null ? formatBytes(value, true, 2) : null),
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => (value != null ? formatBytes(value, true, 2) : null),
                        },
                    },
                },
                series: this.networkOutSeries,
            };
        },
        averageNetworkIn() {
            if (this.installation.metrics && this.installation.metrics.length > 0) return Math.round(this.installation.totalByteReceived / this.installation.metrics.length);
            return 0;
        },
        averageNetworkOut() {
            if (this.installation.metrics && this.installation.metrics.length > 0) return Math.round(this.installation.totalByteSent / this.installation.metrics.length);
            return 0;
        },
    },
    props: {
        installation: Object as () => InstallationWebSocketMetric,
    },
    methods: { formatBytes },
});
